import privacyNoticeService, { type PrivacyNotice } from '../services/privacyNotice.service';
import { useLegalDocument } from './useLegalDocument';

export interface PrivacyNoticeState {
  /** The notice in force, once it has been read. */
  notice: PrivacyNotice | null;
  /** True when it could not be read: a form that cannot show the text cannot take the consent. */
  unavailable: boolean;
  /** Reads it again (the version in force moved while the page was open). */
  reload: () => void;
}

/** The privacy notice in force. A form that takes personal data shows it and echoes its version. */
export function usePrivacyNotice(): PrivacyNoticeState {
  const { document, unavailable, reload } = useLegalDocument(() => privacyNoticeService.current());
  return { notice: document, unavailable, reload };
}
